import ContentDefault from 'components/Shared/ContentDefault';
import { getParamUrl } from 'helpers/getParamsUrl';
import { IProductNew } from 'interfaces/product';
import React, { memo, useEffect, useState } from 'react';
import authService from 'services/auth';

import { productNewService } from 'services/productNewService';
import ListProduct from './List';

function ProductManager() {
  const [canAffiliateAccess, setCanAffiliateAcess] = useState<boolean>(null);

  useEffect(() => {
    authService.getPermissions().subscribe(p => setCanAffiliateAcess(p.myProducts.canAccess));

    productNewService.loadProducts().subscribe(({ products }) => {
      const productIdSelected = getParamUrl('productId');
      if (!productIdSelected) {
        return;
      }

      let productSelectedParameter: IProductNew = null;

      products.every(product => {
        if (product.id === Number(productIdSelected)) {
          productSelectedParameter = product;
        }

        const children = product.children.find(p => p.id === Number(productIdSelected));
        if (!!children) {
          productSelectedParameter = children;
        }

        return !Boolean(productSelectedParameter);
      }, {});

      if (!productSelectedParameter || !!productSelectedParameter?.children?.length) {
        return;
      }

      productNewService.setSelectedProduct(productSelectedParameter);
    });
  }, []);

  if (!canAffiliateAccess) {
    return null;
  }

  return (
    <ContentDefault
      information={'Aumente as chances de conversão do seu checkout com variadas personalizações.'}
      canAffiliateAccess={canAffiliateAccess}
      title="Meus Produtos"
      componentRender={<ListProduct />}
    />
  );
}

export default memo(ProductManager);
